import {getFriendAndFamilyCugType} from './getFriendAndFamilyCugType'
import {getPlusCugType, TokenFromUrlParams} from './getPlusCugType'
import {
  APP_META_CUG_TYPE,
  APP_META_SIGNED_IN_CUG_TYPE,
  APP_WEB_CUG_TYPE,
  OFFLINE_CUG_TYPE,
  SENSITIVE_CUG_TYPE,
  SIGNED_IN_CUG_TYPE,
  WEB_2_APP_CUG_TYPE
} from './privateDeals'

interface CugDealsParameters {
  isMemberPlus: boolean
  isEmployee: boolean
  urlParams: TokenFromUrlParams
  isBrandOffersLockedByDefault?: boolean
  isAppLockedDealAudience?: boolean
}

/**
 * Returns an array of CUG (Closed User Group) types based on user permissions and context
 * @param params - Parameters object
 * @param params.isMemberPlus - Whether the user is a Plus member
 * @param params.isEmployee - Whether the user is an employee
 * @param params.urlParams - URL parameters containing potential tokens
 * @param params.isBrandOffersLockedByDefault - Whether brand offers should be locked by default
 * @param params.isAppLockedDealAudience - Whether the user is in the app-locked deals audience
 * @returns Array of CUG types the user has access to
 */
export const getCugDealsParameter = ({
  isMemberPlus,
  isEmployee,
  urlParams,
  isBrandOffersLockedByDefault = true,
  isAppLockedDealAudience = false
}: CugDealsParameters) => {
  return [
    SIGNED_IN_CUG_TYPE,
    OFFLINE_CUG_TYPE,
    SENSITIVE_CUG_TYPE,
    APP_META_CUG_TYPE,
    APP_META_SIGNED_IN_CUG_TYPE,
    APP_WEB_CUG_TYPE,
    ...getPlusCugType(isMemberPlus, urlParams, isBrandOffersLockedByDefault),
    ...getFriendAndFamilyCugType(isEmployee),
    ...(isAppLockedDealAudience ? [WEB_2_APP_CUG_TYPE] : [])
  ]
}
